import { render, staticRenderFns } from "./AwsUpgradeModal.vue?vue&type=template&id=4c710376"
import script from "./AwsUpgradeModal.vue?vue&type=script&lang=js"
export * from "./AwsUpgradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports